import React from 'react';
import styled, { css } from 'styled-components';
import { Spacing4, Spacing16 } from 'autogen/design-tokens/tokens';
import type { SessionMenuViewModel } from 'autogen/swagger/all';
import SessionMenuItem from 'components/SessionMenu/components/Items';
import useRequestContext from 'hooks/user/useRequestContext';
import { breakpoint, sizes } from 'variables';
import KickIpadSessionMenu from './components/KickIpadSessionMenu';

/* #region  styles */
const MenuContainer = styled.nav`
    display: grid;
    grid-template-columns: repeat(auto-fit, 40px);
    min-height: 32px;
    justify-content: flex-end;
    grid-auto-flow: column;
    width: 100%;
    gap: ${Spacing4};

    ${breakpoint.up('375px')} {
        grid-template-columns: repeat(auto-fit, minmax(40px, max-content));
        gap: ${Spacing16};
    }

    ${breakpoint.up('1025px')} {
        grid-template-columns: repeat(auto-fit, minmax(56px, max-content));
    }
`;

const HideOnMobile = css`
    display: none;

    ${breakpoint.up(sizes.sm)} {
        display: flex;
    }
`;
/* #endregion */

export default function SessionMenu({ model }: { model: SessionMenuViewModel }) {
    const { favoriteIconUrl, findStoreUrl, basketLinkAction, myProfile, tooltips } = model;
    const { isKicksIpadPosRequest } = useRequestContext();

    if (isKicksIpadPosRequest) return <KickIpadSessionMenu model={model} />;

    return (
        <MenuContainer>
            {findStoreUrl && <SessionMenuItem.FindStore linkAction={findStoreUrl} css={HideOnMobile} />}
            <SessionMenuItem.MyProfile model={myProfile} tooltips={tooltips} />
            <SessionMenuItem.Favorite model={favoriteIconUrl} />
            <SessionMenuItem.Basket linkAction={basketLinkAction} />
        </MenuContainer>
    );
}
